import React from 'react'
import Spacing from 'components/Common/Spacing'
import BodyText from 'components/Luxkit/Typography/BodyText'
import styled from 'styled-components'
import { verticalChildSpacing } from 'components/utils/spacing'
import TextLink from 'components/Luxkit/TextLink'
import { useTranslation } from 'react-i18next'

const Stack = styled.div`
  ${verticalChildSpacing[20]}
`

interface Props {
  traderInformation: App.TraderInformation;
}

function TraderInformation(props: Props) {
  const { traderInformation } = props

  const { t } = useTranslation('offerPage')

  const body = []
  if (traderInformation.address) {
    const address = []
    if (traderInformation.address.line1) {
      body.push(traderInformation.address.line1)
    }
    if (traderInformation.address.line2) {
      body.push(traderInformation.address.line2)
    }
    if (traderInformation.address.line3) {
      body.push(traderInformation.address.line3)
    }
    if (traderInformation.address.city) {
      address.push(traderInformation.address.city)
    }
    if (traderInformation.address.stateProvinceCode) {
      address.push(traderInformation.address.stateProvinceCode)
    }
    if (traderInformation.address.postalCode) {
      address.push(traderInformation.address.postalCode)
    }
    if (traderInformation.address.countryCode) {
      address.push(traderInformation.address.countryCode)
    }
    if (address.length > 0) {
      body.push(address.join(' '))
    }
    if (traderInformation.email) {
      body.push(traderInformation.email)
    }
    if (traderInformation.phone) {
      body.push(traderInformation.phone)
    }
  }

  return (
    <Stack>
      {(body.length > 0 || traderInformation.name) && (
        <Spacing mt={12}>
          {traderInformation.name && <BodyText variant="medium" weight="bold">{traderInformation.name}</BodyText>}
          {body.map((info, index) => <BodyText key={index} variant="medium">{info}</BodyText>)}
        </Spacing>
      )}
      <Spacing mt={12}>
        <BodyText variant="medium">{t('traderInformationDisclaimer', { ns: 'offerPage' })}</BodyText>
      </Spacing>
      {traderInformation.termsAndConditions && <Spacing mt={12}>
        <TextLink weight="regular" href={traderInformation.termsAndConditions} target="_blank">
          {t('Terms & conditions', { ns: 'offerPage' })}
        </TextLink>
      </Spacing>}
    </Stack>
  )
}

export default React.memo(TraderInformation)
